import AMapLoader from '@amap/amap-jsapi-loader';
function fetchSignatureParams() {
    return new Promise((resolve, reject) => {
      // 发送请求到服务器端获取签名参数的接口
      axios.get('/your-server-endpoint')
        .then(response => {
          const { timestamp, nonceStr, signature } = response.data;
          resolve({ timestamp, nonceStr, signature });
        })
        .catch(error => {
          reject(error);
        });
    });
  }
export function getLocationWithWx(){
    wx.config({
        appId: 'wx5b7ea8c7c51067a2',
        timestamp: 'your_timestamp',
        nonceStr: 'your_noncestr',
        signature: 'your_signature',
        jsApiList: ['getLocation']
      });
    return new Promise((resolve,reject)=>{
        wx.ready(function() {
            wx.getLocation({
              type: 'wgs84',
              success: function(res) {
                var latitude = res.latitude;  // 纬度
                var longitude = res.longitude;  // 经度
                var accuracy = res.accuracy;  // 精度
                resolve({"lat":res.latitude,"lng":res.longitude})
                // 处理定位信息
              },
              fail: function(error) {
                // 处理定位失败情况
              }
            });
          });
          
    })      
}
export function getLocation() {
    // 获取当前位置的经纬度
    AMapLoader.load({
        key: "4d04d01e19c452f6c95d93fb91e63061",             // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Geolocation'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    }).then((AMap) => {
        AMap.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
                // 是否使用高精度定位，默认：true
                enableHighAccuracy: true,
                // 设置定位超时时间，默认：无穷大
                timeout: 10000,
                // 定位按钮的停靠位置的偏移量
                offset: [10, 20],
                //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                zoomToAccuracy: true,
                //  定位按钮的排放位置,  RB表示右下
                position: 'RB'
            })

            geolocation.getCurrentPosition(function (status, result) {
                if (status == 'complete') {
                    onComplete(result)
                } else {
                    onError(result)
                }
            });

            function onComplete(data) {
                console.log(data)
                // data是具体的定位信息
            }

            function onError(data) {
                console.log(data)
                // 定位出错
            }
        })
    }).catch(e => {
        console.log(e);
    })


}
export function getLocationWithB() {
    var map = new BMapGL.Map("allmap");
    var point = new BMapGL.Point(116.331398, 39.897445);
    map.centerAndZoom(point, 12);

    var geolocation = new BMapGL.Geolocation();
    // 开启SDK辅助定位
    geolocation.enableSDKLocation();
    geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            var mk = new BMap.Marker(r.point);
            map.addOverlay(mk);
            map.panTo(r.point);
            alert('您的位置：' + r.point.lng + ',' + r.point.lat);
        }
        else {
            alert('failed' + this.getStatus());
        }
    });


}
export async function lib_getPosition() {
    const BMap = window.BMapGL;
    const BMapGeolocation = new BMap.Geolocation();
    return new Promise((resolve,reject)=>{
        BMapGeolocation.getCurrentPosition((r) => {
            console.log(r)
            if (r.latitude && r.longitude) {
                console.log("baidu");
                // 获取到经纬度（百度转换高德经纬度）
                console.log(r.latitude, r.longitude)
                resolve(r)
            } else {
                console.log(22);
            }
        });

    })
   
}




// WEBPACK FOOTER //
// ./src/utils/getLocation.js